import { InputField } from 'shared/ui/InputField';
import { useTranslation } from 'react-i18next';

const StringLabel = () => {
	const { t } = useTranslation();

	return (
		<>
			<InputField
				name={'name'}
				label={t('files.labels.research')}
				placeholder={t('files.search_placeholder')}
				required
			/>

			<InputField
				name={'description'}
				label={t('files.labels.rule')}
				placeholder={t('files.rule_placeholder')}
				multiline
				maxRows={3}
			/>
		</>
	);
};

export default StringLabel;
